export const getEnvValue = (key) =>
  (typeof import.meta !== 'undefined' && import.meta.env?.[key]) || process.env[key];
